import React, { useEffect, useId, useRef } from 'react'
import './Checkbox.sass'

const Checkbox: React.FC<{
    label: string
    checked: boolean
    disabled?: boolean
    indeterminate?: boolean
    ariaLabel?: string
    customClassName?: string
    onCheckChange: (newVal: boolean) => void
}> = ({ label, checked, disabled, indeterminate, ariaLabel, customClassName, onCheckChange }) => {
    const id = useId()
    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (inputRef.current) inputRef.current.indeterminate = !!indeterminate
    }, [indeterminate])

    return (
        <div
            className={`md-checkbox ${disabled ? 'disabled-checkbox' : ''} ${
                indeterminate ? 'indeterminate-checkbox' : ''
            } ${customClassName ?? ''}`}
        >
            <input
                ref={inputRef}
                id={`icoone-checkbox__${id}`}
                type="checkbox"
                disabled={disabled}
                checked={checked}
                aria-label={ariaLabel}
                onChange={(e) => onCheckChange(e.target.checked)}
            />
            <label htmlFor={`icoone-checkbox__${id}`}>{label}</label>
        </div>
    )
}

export default Checkbox
